import React from 'react';
import { Text, TEXT_VIEW } from "../../../Text";
export function createTextValueControl(_a) {
    var _b = (_a === void 0 ? {} : _a).valueRenderer, valueRenderer = _b === void 0 ? function (value, disabled) { return (React.createElement(Text, { view: disabled ? TEXT_VIEW.light : TEXT_VIEW.primary }, value)); } : _b;
    return function textValueControlRenderer(_a) {
        var disabled = _a.disabled, options = _a.options, value = _a.value, onValueChange = _a.onValueChange;
        var textValueElement = valueRenderer(value, !!disabled);
        if (typeof textValueElement === 'string') {
            return (React.createElement(Text, { view: disabled ? TEXT_VIEW.light : TEXT_VIEW.primary }, textValueElement));
        }
        return textValueElement;
    };
}
//# sourceMappingURL=textValueControlRenderer.js.map